import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import Loading from '../ui/Loading';
import { setTypeOfShowModalType } from '../../features/modal/modalSlice';
import { useQueryData } from '../../hooks/api/useQueryData';
import { useGetUserInitial } from '../../hooks/useGetUserInitial';

export default function UserDetails() {

    const dispatch = useDispatch()
    const userInitial = useGetUserInitial()
    const { userInfo, isErrorUserInfo, errorMessageUserInfo, isLoadingUserInfo } = useQueryData()
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleResize);
        
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleViewAndUpdateAccount = () => {
        dispatch(setTypeOfShowModalType("viewProfileDetails"))
    }

    return (
        <div className={`absolute top-full right-0 mt-[18px] min-w-[240px] md:w-[300px] h-200px bg-white ${isErrorUserInfo ? 'h-[150px]' : 'h-auto'} shadow-lg rounded-lg flex flex-col overflow-hidden p-2.5`}
            style={{ 
                maxHeight: `${windowHeight - 100}px`, 
                overflowY: "auto", 
                zIndex: '20'
            }}
        >   
            { isLoadingUserInfo ? (
                <Loading  message='Loading...'  setH={'h-[150px]'} />
            ) : isErrorUserInfo ? (
                <div className='flex text-center items-center justify-center h-full'>
                    {errorMessageUserInfo}
                </div>
            ) : (
                <div className='flex flex-col space-y-2'>
                    <div className='flex space-x-2'>
                        <button
                        className={`relative text-sm px-4 py-2 rounded-lg font-medium transition-all bg-cbColor text-white shadow-md`}
                        >
                            {userInitial}
                        </button>
                        <div className='flex flex-col'>
                            <p className='text-sm font-medium'>
                                {`${userInfo?.firstName} ${
                                    userInfo?.middleInitial ? userInfo?.middleInitial + ". " : ""
                                }${userInfo?.lastName}`}
                            </p>
                            <p className='text-sm'>{userInfo?.email}</p>
                        </div>
                    </div>
                    <p 
                        className='text-[13px] text-center text-blue-700 hover:underline cursor-pointer'
                        onClick={handleViewAndUpdateAccount}
                    >
                        View Account
                    </p>
                </div>
            )}
        </div>
    )
}